export default __webpack_public_path__ + "static/media/close.7d131f14.svg";